// components/TrailerModal.js
import React, { useEffect, useRef } from 'react';
import '../styles/main.css';

const TrailerModal = ({ isOpen, onClose, youtubeKey }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close modal if click occurs outside trailer container
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      // Add event listener when modal is open
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`trailer-modal ${isOpen ? 'active' : ''}`} id="trailerModal">
      <div className="close-trailer" id="closeTrailer" onClick={onClose}>
        <i className="fas fa-times"></i>
      </div>
      <div className="trailer-container" ref={modalRef}>
        <iframe
          className="trailer-iframe"
          id="trailerIframe"
          src={`https://www.youtube.com/embed/${youtubeKey}?autoplay=1&rel=0&modestbranding=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Movie Trailer"
        ></iframe>
      </div>
    </div>
  );
};

export default TrailerModal;